import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import Services from "./pages/services";
import Availabilities from "./pages/availabilities";
import Appointments from "./pages/appointments";
import Formations from "./pages/formations";
import ShowFormation from "./pages/formations/show";
import Orders from "./pages/orders";

function App() {
    const isAuthenticated = true; // TODO: gérer avec un vrai state

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                    path="/dashboard"
                    element={
                        isAuthenticated ? (
                            <DashboardLayout />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    }
                >
                    <Route index element={<Dashboard />} />
                    <Route path="services" element={<Services />} />
                    <Route path="availabilities" element={<Availabilities />} />
                    <Route path="appointments" element={<Appointments />} />
                    <Route path="formations" element={<Formations />} />
                    <Route path="formations/:id" element={<ShowFormation />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="profile" element={<Profile />} />
                </Route>

                {/* Redirection par défaut */}
                <Route path="*" element={<Navigate to="/login" replace />} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
